const Colors = {
    BACKGROUND: '#EDF2F3',
    PRIMARY_GREEN: "#009F46",
    GREY: '#8A989B',
    ORANGE: '#FF982B',
    RED: '#C14545',
    WHITE: '#fff',
    BLACK: '#000',
    DARK_GREY: '#5D686B'
}

export default Colors